/**
 * Title Case for the lineup page's alert banners, which capitalize every word.
 *
 * Only the first character of each word is touched and the rest is left alone,
 * which is the whole point: lowercasing the remainder would turn "UCF" into
 * "Ucf", "Texas A&M" into "Texas A&m" and the "5x Play" into something else
 * again. Team names and rule names reach these messages by interpolation, so
 * they have to survive it.
 *
 * Applied once where the banner renders rather than to each message, so a
 * message added later cannot forget.
 */
export function titleCase(text) {
  if (typeof text !== "string") return text;
  return text.replace(/(^|\s)(\S)/g, (_, lead, first) => lead + first.toUpperCase());
}
